export const createProgramSiteCoreKeys = {
  informationPopup: "InformationPopup",
  description: "Description",
  cancelChanges: "CancelChanges",
  areYouSureToCancel: "CancelChanges.AreYouSureToCancel",
  manageLocale: "ManageLocale",
  viewLocaleTitle: "ManageLocale.ViewLocale",
  defaultEventsList: "DefaultEventsList",
  statusList: "ProgramTemplateProfileSection.StatusList",
  statusAll: "Status.All",

  activitiesList: "ActivitiesList",
  createActivity: "ActivitiesList.CreateActivityLink",
  activityTypeHeader: "ActivitiesList.ActivityType",
  modalityHeader: "ActivitiesList.Modality",
  topicHeader: "ActivitiesList.Topic",
  activityClassHeader: "ActivitiesList.ActivityClass",
  activityStatusHeader: "ActivitiesList.ActivityStatus",
  measurementHeader: "ActivitiesList.Quantity",
  unitsHeader: "ActivitiesList.Units",
  candidateStatusHeader: "ActivitiesList.CandidateStatus",
  actionHeader: "ActivitiesList.Action",
  activitiesNotAvailable: "ActivitiesList.ActivitiesNotAvailable",
  deliverablesNotAvailable: "DeliverablesList.DeliverablesNotAvailable",
  programFramework: "ActivitiesList.ProgramFramework",
  deleteActivityConfirmation: "ActivitiesList.DeleteActivityActionText",
  deletingActivity: "ActivitiesList.DeletingActivity",
  activityDeletedSuccessfully: "ActivitiesList.DeleteActivityCompletionText",
  listCandidateStatusList: "ActivitiesList.CandidateStatusList",
  listStatusList: "ActivitiesList.StatusList",
  listActivityTypeList: "ActivitiesList.ActivityTypeList",
  listModalityList: "ActivitiesList.ModalityList",
  listActivityClassList: "ActivitiesList.ActivityClassList",
  listUnitList: "ActivitiesList.UnitLists",
  listMinutesList: "ActivitiesList.MinutesList",
  thisActivityCannotBeDeletedBecauseItIsTaggedToAnExistingProgram:
    "ActivitiesList.ThisActivityCannotBeDeletedBecauseItIsTaggedToAnExistingProgram",

  profileSection: "ProgramTemplateProfileSection",
  editProgramTemplate: "ProgramTemplateProfileSection.EditProgramTemplate",
  viewProgramTemplate: "ProgramTemplateProfileSection.ViewProgramTemplate",
  nameLabel: "ProgramTemplateProfileSection.Name",
  nameLanguageSpecificLabel:
    "ProgramTemplateProfileSection.NameLanguageSpecific",
  productLine: "ProgramTemplateProfileSection.ProductLine",
  programFrameworkLabel: "ProgramTemplateProfileSection.ProgramFramework",
  solutionCategoryLabel: "ProgramTemplateProfileSection.SolutionCategory",
  solutionSubCategory: "ProgramTemplateProfileSection.SolutionSub-Category",
  nextViewLabel: "ProgramTemplateProfileSection.NextView",
  nextViewNotEditableErrorMessage:
    "ProgramTemplateProfileSection.NEXTViewNotEditableErrorMessage",
  nextProgramClassLabel: "ProgramTemplateProfileSection.NextProgramClass",
  countryLabel: "ProgramTemplateProfileSection.Country",
  countrys: "CreateProgramTemplateComponent.CompatibleTemplate.Countrys",
  selectRegionType:
    "CreateProgramTemplateComponent.CompatibleTemplate.SelectRegionType",
  regionTypeList:
    "CreateProgramTemplateComponent.CompatibleTemplate.RegionTypeList",
  multipleCountries: "RegionType.MultipleCountries",
  regionTypeGlobal: "RegionType.Global",
  defaultEventsLabel: "ProgramTemplateProfileSection.DefaultEvents",
  durationMonthsLabel: "ProgramTemplateProfileSection.DurationMonths",
  statusLabel: "ProgramTemplateProfileSection.Status",
  programTemplateBeingCreatedMessage:
    "ProgramTemplateProfileSection.ProgramTemplateBeingCreatedMessage",
  programTemplateBeingUpdatedMessage:
    "ProgramTemplateProfileSection.ProgramTemplateBeingUpdatedMessage",
  programTemplateCreatedMessage:
    "ProgramTemplateProfileSection.ProgramTemplateCreatedMessage",
  programTemplateUpdatedMessage:
    "ProgramTemplateProfileSection.ProgramTemplateUpdatedMessage",
  nameWithUs: "ProgramTemplateProfileSection.NameLanguageSpecific",
  programTemplateSaveMessage:
    "ProgramTemplateProfileSection.ProgramTemplateSaveMessage",
  programTemplateDuplicateCheckMessage:
    "ProgramTemplateProfileSection.ProgramTemplateDuplicateCheckMessage",
  closingReasonType: "ProgramTemplateProfileSection.ClosingReasonType",
  closingReasonTypeList: "ClosingReasonTypeList",
  nextAccessLabel: "ProgramTemplateProfileSection.NextAccess",
  nextAccessList: "ProgramTemplateProfileSection.NextAccessList",
  nextAccessYes: "NextAccess.Yes",
  nextAccessNo: "NextAccess.No",

  createActivityKey: "CreateActivity",
  updateLocale: "CreateActivity.UpdateLocale",
  updateLocaleActionMessage: "CreateActivity.UpdateLocaleActionMessage",
  generalTab: "CreateActivity.GeneralTab",
  defaultActivityValues: "CreateActivity.DefaultActivityValues",
  activityNote: "CreateActivity.IsProgramTemplateSpecificActivityNote",
  participantStatus: "CreateActivity.ParticipantStatus",
  activityType: "CreateActivity.ActivityType",
  activityClass: "CreateActivity.ActivityClass",
  modality: "CreateActivity.Modality",
  topic: "CreateActivity.Topic",
  deliverables: "CreateActivity.Deliverables",
  activityStatus: "CreateActivity.ActivityStatus",
  candidateStatusList: "CreateActivity.CandidateStatusList",
  activityTypeList: "CreateActivity.ActivityTypeList",
  modalityList: "CreateActivity.ModalityList",
  activityClassList: "CreateActivity.ActivityClassList",
  activityStatusList: "CreateActivity.StatusList",
  selectedDeliverables: "CreateActivity.SelectedDeliverables",
  selectApplicable: "CreateActivity.SelectApplicable",
  triggerBilling: "CreateActivity.TriggerBilling",
  countsTowardsLastContactDate: "CreateActivity.CountsTowardsLastContactDate",
  triggerTouchPointSurvey: "CreateActivity.TriggerTouchPointSurvey",
  waitActivityCreatingMessage: "CreateActivity.WaitActivityCreatingMessage",
  activityCreatedMessage: "CreateActivity.ActivityCreatedMessage",
  editActivityButton: "CreateActivity.EditActivityButton",
  viewActivityPopupTitle: "CreateActivity.ViewActivityPopupTitle",
  frameworkSpecificActivityNote:
    "CreateActivity.ProgramFrameworkSpecificActivityNote",
  selectedOptionsText: "CreateActivity.SelectedOptionsText",
  activityProgramFramework: "CreateActivity.ProgramFramework",
  willTemplateNote: "CreateActivity.WillProgramTemplateSpecificActivityNote",
  editActivityPopupTitle: "CreateActivity.EditActivityPopupTitle",
  activityUpdatedMessage: "CreateActivity.ActivityUpdatedMessage",
  waitActivityUpdatingMessage: "CreateActivity.ActivityUpdatedWaitMessage",
  isEditFrameworkText:
    "CreateActivity.IsProgramTemplateSpecificActivityTypeText",
  noDeliverablesAvailable: "CreateActivity.NoDeliverablesAvailableMessage",
  noTaggedDeliverablesTooltip:
    "CreateActivity.YouHaventTaggedAnyDeliverablesToThisActivityYetTooltipMessage",
  topicForOtherLanguagesWarningMessage:
    "CreateActivity.TopicForOtherLanguagesWarningMessage",

  halfDay: "DefaultActivityValues.HalfDay",
  units: "DefaultActivityValues.Units",
  defaultActivityKey: "DefaultActivityValues",
  unitLists: "DefaultActivityValues.UnitLists",
  minutesList: "DefaultActivityValues.MinutesList",
  minutes: "DefaultActivityValues.Minutes",
  quantity: "DefaultActivityValues.Quantity",
  numberofDays: "DefaultActivityValues.NumberofDays",
  country: "DefaultActivityValues.Country",
  measurement: "DefaultActivityValues.Measurement",
  addException: "DefaultActivityValues.AddException",
  exceptions: "DefaultActivityValues.Exceptions",
  defaultActivityCountry: "DefaultActivityValues.Country",
  action: "DefaultActivityValues.Action",
  deleteException: "DefaultActivityValues.DeleteException",

  createDeliverableKey: "CreateDeliverable",
  createDeliverableUnitList: "CreateDeliverable.UnitsList",
  createDeliverableMinuteList: "CreateDeliverable.MinutesList",
  createDeliverablesMinutesLabel: "CreateDeliverable.Minutes",
  deliverableTypeList: "CreateDeliverable.DeliverableTypeList",
  addDeliverable: "CreateDeliverable.AddDeliverable",
  selectType: "CreateDeliverable.SelectType",
  addNewDeliverable: "CreateDeliverable.AddNewDeliverable",
  selectExistingDeliverables: "CreateDeliverable.SelectExistingDeliverables",
  deliverableType: "CreateDeliverable.DeliverableType",
  createDeliverableUnits: "CreateDeliverable.Units",
  deliverableName: "CreateDeliverable.DeliverableName",
  deliverableUpdatedMessage: "CreateDeliverable.DeliverableUpdatedMessage",
  deliverableAddedMessage: "CreateDeliverable.DeliverableAddedMessage",
  createDeliverableMinutes: "CreateDeliverable.Minutes",
  createDeliverableNumberOfDays: "CreateDeliverable.NumberOfDays",
  createDeliverableQuantity: "CreateDeliverable.Quantity",

  deliverablesListKey: "DeliverablesList",
  addDeliverablesLabel: "DeliverablesList.AddDeliverables",
  editDeliverableButtonText: "DeliverablesList.EditDeliverableButtonText",
  viewDeliverable: "DeliverablesList.ViewDeliverable",
  deliverableViewType: "DeliverablesList.DeliverableType",
  deliverablesViewName: "DeliverablesList.DeliverableName",
  deliverablesActivityType: "DeliverablesList.ActivityType",
  deliverablesUnits: "DeliverablesList.Units",
  deliverablesMeasurement: "DeliverablesList.Measurement",
  selectedActivities: "DeliverablesList.SelectedActivities",
  createDeliverableMeasurement: "CreateDeliverable.Measurement",
  existingDeliverables: "CreateDeliverable.ExistingDeliverables",
  deliverableSaveAlertMessage: "CreateDeliverable.DeliverableSaveAlertMessage",
  deleteDeliverableConfirmation: "DeliverablesList.DeleteDeliverableActionText",
  deletingDeliverable: "DeliverablesList.DeletingDeliverableText",
  deleteDeliverableSuccess: "DeliverablesList.DeleteDeliverableSuccessText",
  editDeliverableTitle: "DeliverablesList.EditDeliverable",
  deliverableUpdated: "DeliverablesList.DeliverableUpdated",

  //compatible template
  compatibleTemplateKey:
    "ProgramTemplateManagement.CreateProgramTemplateComponent.CompatibleTemplate",
  compatibleAction: "CreateProgramTemplateComponent.CompatibleTemplate.Action",
  addTemplateSubTitle:
    "CreateProgramTemplateComponent.CompatibleTemplate.AddTemplateSubTitle",
  compatibleProgramTemplate:
    "CreateProgramTemplateComponent.CompatibleTemplate.CompatibleProgramTemplate",
  compatibleCountry:
    "CreateProgramTemplateComponent.CompatibleTemplate.Country",
  compatibleTemplateSubTitle:
    "CreateProgramTemplateComponent.CompatibleTemplate.CompatibleTemplateSubTitle",
  duration: "CreateProgramTemplateComponent.CompatibleTemplate.Duration",
  notAvailableMessageCompatible:
    "CreateProgramTemplateComponent.CompatibleTemplate.NotAvailableMessage",
  deletingCompatibleTemplateWaitMessage:
    "CreateProgramTemplateComponent.CompatibleTemplate.DeletingCompatibleTemplateWaitMessage",
  deleteCompatibleTemplateConirmationMessage:
    "CreateProgramTemplateComponent.CompatibleTemplate.DeleteCompatibleTemplateConirmationMessage",
  compatibleTemplateDeletedMessage:
    "CreateProgramTemplateComponent.CompatibleTemplate.CompatibleTemplateDeletedMessage",
  addingCompatibleTemplateWaitMessage:
    "CreateProgramTemplateComponent.CompatibleTemplate.AddingCompatibleTemplateWaitMessage",
  compatibleTemplateAddedMessage:
    "CreateProgramTemplateComponent.CompatibleTemplate.CompatibleTemplateAddedMessage",
  durationAlertMessage:
    "CreateProgramTemplateComponent.CompatibleTemplate.DurationAlertMessage",
};
